/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import get from 'transmute/get';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import PhoneFromNumberOptionsWorkspace from './PhoneFromNumberOptionsWorkspace';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { memo, useMemo, useState } from 'react';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallSettingWrapper = styled.div.withConfig({
  displayName: "CurrentSettingsInfoWorkspace__CallSettingWrapper",
  componentId: "sc-172oav8-0"
})(["cursor:pointer;font-weight:", ";background-color:transparent;&.is--disabled{opacity:0.5;}&:hover{background-color:", ";}"], WEB_FONT_MEDIUM_WEIGHT, CALYPSO_LIGHT);
const BodyWrapper = styled.div.withConfig({
  displayName: "CurrentSettingsInfoWorkspace__BodyWrapper",
  componentId: "sc-172oav8-1"
})(["margin:-20px -24px 0;"]);
const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "CurrentSettingsInfoWorkspace__StyledUIIcon",
  componentId: "sc-172oav8-2"
})(["float:right;"]);
function CurrentSettingsInfoWorkspace({
  appIdentifier,
  selectedCallProvider,
  selectedFromNumber,
  handleSelectFromNumber,
  channelAssignedPhoneNumbers
}) {
  const [showPhoneFromNumberOptions, setShowPhoneFromNumberOptions] = useState(false);
  const providerName = useMemo(() => get('name', selectedCallProvider), [selectedCallProvider]);
  let numberOrProvider = providerName;
  if (selectedFromNumber) {
    if (selectedFromNumber.get('nickname') && selectedFromNumber.get('nickname').length) {
      numberOrProvider = `${selectedFromNumber.get('nickname')} ${selectedFromNumber.get('friendlyName')}`;
    } else if (selectedFromNumber.get('friendlyName')) {
      numberOrProvider = selectedFromNumber.get('friendlyName');
    }
  }
  return /*#__PURE__*/_jsx(UIPopover, {
    open: showPhoneFromNumberOptions,
    onOpenChange: () => setShowPhoneFromNumberOptions(false),
    animateOnToggle: true,
    width: "300px",
    content: {
      body: /*#__PURE__*/_jsx(BodyWrapper, {
        children: /*#__PURE__*/_jsx(PhoneFromNumberOptionsWorkspace, {
          appIdentifier: appIdentifier,
          channelAssignedPhoneNumbers: channelAssignedPhoneNumbers,
          selectedFromNumber: selectedFromNumber,
          onSelect: handleSelectFromNumber
        })
      })
    },
    placement: "right bottom",
    arrowSize: "none",
    children: /*#__PURE__*/_jsxs(CallSettingWrapper, {
      className: "p-x-4 p-y-3",
      onClick: () => setShowPhoneFromNumberOptions(!showPhoneFromNumberOptions),
      "data-selenium-test": "open-pre-call-popup-from-numbers",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "callSettingsWidget.callFrom",
        options: {
          numberOrProvider
        }
      }), /*#__PURE__*/_jsx(StyledUIIcon, {
        name: "right",
        size: "xxs"
      })]
    })
  });
}
CurrentSettingsInfoWorkspace.propTypes = {
  appIdentifier: PropTypes.string,
  selectedCallProvider: RecordPropType('CallingProvider'),
  selectedFromNumber: RecordPropType('FromNumberRecord'),
  handleSelectFromNumber: PropTypes.func,
  channelAssignedPhoneNumbers: ImmutablePropTypes.listOf('FromNumberRecord')
};
export default /*#__PURE__*/memo(CurrentSettingsInfoWorkspace);